const WorkDetail = [
    {
        id:"1",
        number:"01",
        heading:"Toda oferta em dinheiro",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"2",
        number:"02",
        heading:"Conheça seu agente",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"3",
        number:"03",
        heading:"Fechar o negócio",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
    {
        id:"4",
        number:"04",
        heading:"Tenha sua propriedade",
        info:"Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem Lorem."
    },
]
export default WorkDetail